import type { BatMetadataConfigEntry } from './common/types';
import { coreFields } from './common/coreFields';
import { genericUnitField } from './common/sharedFields';
import { locationFields } from './common/locationFields';
import { vendorFields } from './common/vendorFields';
import { isThirdPartyField, productFields } from './common/productFields';
import { cleanPowerFields } from './common/cleanPowerFields';
import { msg } from '@lingui/core/macro';
import { electricityUsageQuantityField } from './common/electricityFields';

export const nonBuildingElectricityConsumptionMetadata = {
  displayName: msg({
    message: 'Electricity consumption',
    context: 'Activity data schema name for electricity consumption',
  }),
  fields: {
    ...coreFields,
    ...locationFields,
    ...vendorFields,
    ...productFields,
    ...cleanPowerFields,
    electricity_consumption_reason: {
      displayName: msg({
        message: 'Electricity consumption reason',
        context: 'What the electricity is used for.',
      }),
      externalDescription: msg({
        message: 'What the electricity is used for.',
        context: 'Electricity consumption reason',
      }),
    },
    is_third_party: isThirdPartyField,
    quantity: electricityUsageQuantityField,
    unit: genericUnitField,
  },
} as const satisfies BatMetadataConfigEntry;
